import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=3ce5571c&scoped=true"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"
import style0 from "./SearchComponent.vue?vue&type=style&index=0&id=3ce5571c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce5571c",
  null
  
)

export default component.exports